module.exports = __webpack_public_path__ + "img/comilla.4eaa557c.svg";